export const getToken = () => localStorage.getItem("token");
export const getRole = () => localStorage.getItem("role");
export const getUserEmail = () => localStorage.getItem("userEmail");

export const getAllowedPages = () => {
  try {
    return JSON.parse(localStorage.getItem("allowedPages")) || [];
  } catch {
    return [];
  }
};

export const clearAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("allowedPages");
};

export const getHomeRouteByRole = (role, allowedPages = []) => {
  if (role === "admin") return "/dashboard";

  if (allowedPages.length > 0) {
    return `/${allowedPages[0]}`;
  }

  return "/page-login";
};

export const hasPageAccess = (page) => {
  const role = getRole();
  const allowedPages = getAllowedPages();

  if (role === "admin") return true;

  return allowedPages.includes(page);
};